<template>
  <div class="xl:hidden">
    <!-- Button -->
    <div class="h-9 flex items-center p-1 text-white md:h-12" @click="toggleMenu">
      <i class="fas fa-ellipsis-v text-xl" />
    </div>

    <!-- Menü -->
    <transition name="fade">
      <div v-if="showMenu">
        <div class="fixed inset-0 z-40 h-screen w-full overflow-hidden">
          <div class="scrollbar shadow-mmenu absolute z-50 h-full w-3/4 flex flex-col bg-white md:w-1/3 sm:w-1/2">
            <div class="mt-2 flex items-center justify-between">
              <button class="flex items-center p-5 text-gray-700" @click="toggleMenu">
                <i class="fal fa-times text-4xl" />
              </button>
              <a class="block p-5" href="/home"><img
                class="h-12"
                src="../../../resources/images/logo/RGB_logo_coloredsmall.png"></a>
            </div>
            <div v-cloak>
              <div class="text-lg">
                <MenuSection
                  v-for="(section, idx) in sections"
                  :key="idx"
                  :active-url
                  :counts
                  :is-server-admin
                  :section />
              </div>
              <div class="grow" />
              <div class="z-60 flex justify-between border-t border-gray-400 px-4 pb-12 pt-4 text-2xl text-black">
                <button class="my-auto block size-6" type="button" @click="logout">
                  <iconify-icon icon="fas:arrow-right-from-bracket" />
                </button>
                <a class="block" href="https://ol-events.zendesk.com/hc/de" rel="noopener" target="_blank">
                  <i class="fas fa-question-circle" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import menu from '@/configs/menu';
import { ref } from 'vue';
import MenuSection from './layout/menuSection.vue';

type Props = {
  counts: Record<string, number>;
  isServerAdmin?: boolean;
};
const props = defineProps<Props>();

const showMenu = ref(false);
const windowTop = ref(0);

function checkPermission(permission?: 'server-admin') {
  if (!permission) return true;
  if (permission === 'server-admin') return props.isServerAdmin;
}
const sections = menu.filter(section => checkPermission(section.permission));

const items = sections.flatMap(section => section.items);

const activeUrl = ref('');

const activeUrlLevel = ref(3);

getActiveUrl();

function getActiveUrl() {
  const currentPath = location.pathname.split('?')[0].replace(/\d+/g, '{id}').replace(/\/$/, '');
  for (const item of items) {
    const itemPath = item.url.replace(new RegExp(`^${document.location.origin.replace('.', '\\.')}`), '');

    if (currentPath === itemPath) {
      setActiveUrl(item.url, 1);
      continue;
    }
    if (item.additionalUrlMatches?.includes(currentPath) || item.additionalUrlMatches?.some(match => currentPath.startsWith(match))) {
      setActiveUrl(item.url, 2);
      continue;
    }
    if (currentPath.startsWith(itemPath)) {
      setActiveUrl(item.url, 3);
    }
  }
}

function setActiveUrl(url: string, level: number) {
  if (!activeUrl.value || activeUrlLevel.value > level) {
    activeUrl.value = url;
    activeUrlLevel.value = level;
  }
}

async function logout() {
  try {
    await useAxios(route('logout'), {
      method: 'post',
    });
    location.reload();
  }
  catch (error) {
    console.log(error);
  }
}

function toggleMenu() {
  showMenu.value = !showMenu.value;

  const zendeskIcon = document.querySelector('#launcher');

  if (zendeskIcon !== undefined && zendeskIcon != undefined) {
    zendeskIcon.style.zIndex = '20';
  }

  // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
  if (showMenu.value) {
    windowTop.value = document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${windowTop.value}px`;
  }
  else {
    document.body.style.position = '';
    document.documentElement.scrollTo(0, windowTop.value || 0);
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
